import type { OrderListItemDTO } from '@wf/shared'
import { STATUS_LABEL } from '../orders/labels'
import { minToTime } from '../orders/schedule'

/**
 * Kompakte Termin-Karte der Plantafel (Redesign 15.07. nach Simons Claude-Design-Entwurf, token-treu
 * adaptiert): Zeitzeile + Status-Chip, Kennzeichen · Modell, Kunde, Auftragsnummer. Als Button (öffnet
 * den Zuweisungs-Dialog) — die Positionierung (top/height/Spur) setzt das Raster per React-Style
 * (CSSOM, CSP-konform wie NavMenu). Status färbt Kante + Chip (Token --st-*).
 */
export function PlanCard({
  order,
  onSelect,
  style,
  compact = false,
}: {
  order: OrderListItemDTO
  onSelect: (order: OrderListItemDTO) => void
  style?: React.CSSProperties
  /** Kurz-Slot (< ~45 Min): einzeilig Zeit + Titel — Chip/Kunde/Fußzeile passen nicht in die Slot-Höhe. */
  compact?: boolean
}) {
  const time =
    order.startMin != null && order.endMin != null ? `${minToTime(order.startMin)}–${minToTime(order.endMin)}` : ''
  const title = [order.plate, order.vehicleModel].filter(Boolean).join(' · ') || order.nr || `#${order.id}`
  // Ohne Kennzeichen/Modell IST der Titel schon die Auftragsnummer — dann nicht doppelt anzeigen.
  const footNr = order.nr != null && title !== order.nr ? order.nr : null
  const ariaTitle = [order.nr, order.plate].filter(Boolean).join(' · ')
  if (compact) {
    return (
      <button
        type="button"
        className={`wf-plancard wf-plancard--compact wf-plancard--${order.status}`}
        style={style}
        onClick={() => onSelect(order)}
        aria-label={`Termin ${ariaTitle || `#${order.id}`}${time ? `, ${time}` : ''}`}
      >
        <span className="wf-plancard__time">{time}</span>
        <span className="wf-plancard__title">{title}</span>
      </button>
    )
  }
  return (
    <button
      type="button"
      className={`wf-plancard wf-plancard--${order.status}`}
      style={style}
      onClick={() => onSelect(order)}
      aria-label={`Termin ${ariaTitle || `#${order.id}`}${time ? `, ${time}` : ''}`}
    >
      <span className="wf-plancard__toprow">
        <span className="wf-plancard__time">{time}</span>
        <span className="wf-plancard__chip">{STATUS_LABEL[order.status] ?? order.status}</span>
      </span>
      <span className="wf-plancard__title">{title}</span>
      {order.customerName ? <span className="wf-plancard__sub">{order.customerName}</span> : null}
      <span className="wf-plancard__foot">
        {footNr ? <span className="wf-plancard__nr">{footNr}</span> : null}
        {order.mechanicName ? (
          <span className="wf-plancard__mech">
            <span className="wf-plancard__mechdot" style={{ background: order.mechanicColor ?? 'var(--muted)' }} aria-hidden="true" />
            {order.mechanicName}
          </span>
        ) : null}
      </span>
    </button>
  )
}
